// src/pages/ForBrands/ForBrands.js
import React from 'react';
import BrandHero from '../../components/ForBrands/BrandHero/BrandHero';
import CarouselComponent from '../../components/BrandsCarousel/BrandsCarousel';
import ContentEquation from '../../components/ForBrands/ContentEquation/ContentEquation';
import CaseStudiesCarousel from '../../components/ForBrands/CaseStudiesCarousel/CaseStudiesCarousel';
import VerticalInfoContainer from '../../components/ForBrands/VerticalInfoContainer/VerticalInfoContainer';
import MessageBox from '../../components/ForBrands/MessageBox/MessageBox';
import PurposeSection from '../../components/PurposeSection/PurposeSection';
import './ForBrands.css';

const ForBrands = () => {
  return (
    <div className="for-brands-container">
      {/* Hero section */}
      <section className="brand-hero-wrapper">
        <div className="container">
          <BrandHero />
        </div>
      </section>

      {/* Carousel with styled background */}
      <section className="carousel-wrapper">
        <CarouselComponent />
      </section>

      {/* Vertical info container */}
      <section className="vertical-info-wrapper">
        <div className="container">
          <VerticalInfoContainer />
        </div>
      </section>

      {/* Case studies with styled background */}
      <section className="case-studies-wrapper">
        <div className="container">
          <CaseStudiesCarousel />
        </div>
      </section>

      {/* Purpose section */}
      <section className="purpose-wrapper">
        <div className="container">
          <PurposeSection />
        </div>
      </section>
    </div>
  );
};

export default ForBrands;
